import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { STORE_LINKS, detectPlatform } from '../utils/storeLinks';

const GetAppPage: React.FC = () => {
  const { t } = useTranslation();
  const platform = detectPlatform();

  // Auto-redirect mobile users to the correct store after a short delay
  // so they can still see the page briefly.
  useEffect(() => {
    if (platform === 'desktop') return;
    const url = platform === 'ios' ? STORE_LINKS.ios : STORE_LINKS.android;
    window.location.href = url;
  }, [platform]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white px-6 text-center">
      <img src="/logo.png" alt="Kol Tora" className="w-24 h-24 rounded-2xl mb-6 shadow-md" />
      <h1 className="text-2xl font-bold mb-2">{t('get_app_title', 'קול תורה')}</h1>
      <p className="text-gray-500 mb-8">
        {t('get_app_subtitle', 'הורד את האפליקציה ולמד לבר מצווה')}
      </p>

      <div className="flex flex-col gap-3 w-full max-w-xs">
        {(platform === 'ios' || platform === 'desktop') && (
          <a
            href={STORE_LINKS.ios}
            className="flex items-center justify-center gap-2 bg-black text-white py-3 px-6 rounded-full font-semibold text-base"
          >
            <span>🍎</span>
            {t('get_app_appstore', 'הורד ב‑App Store')}
          </a>
        )}
        {(platform === 'android' || platform === 'desktop') && (
          <a
            href={STORE_LINKS.android}
            className="flex items-center justify-center gap-2 bg-green-700 text-white py-3 px-6 rounded-full font-semibold text-base"
          >
            <span>▶</span>
            {t('get_app_playstore', 'הורד ב‑Google Play')}
          </a>
        )}
      </div>

      <a href="/" className="mt-8 text-sm text-gray-400 underline">
        {t('get_app_continue_web', 'המשך לאתר')}
      </a>
    </div>
  );
};

export default GetAppPage;
